var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5112 7.42056H12.3649V5.51402C12.3649 4.6729 11.7045 4 10.879 4H5.48587C4.66039 4 4 4.6729 4 5.51402V11.0093C4 11.8505 4.66039 12.5234 5.48587 12.5234H7.63213V14.486C7.63213 15.3271 8.29251 16 9.11799 16H14.5112C15.3366 16 15.997 15.3271 15.997 14.486V8.99065C16.0521 8.09346 15.3366 7.42056 14.5112 7.42056ZM5.04561 11.0093V5.51402C5.04561 5.28972 5.21071 5.1215 5.43084 5.1215H10.824C11.0441 5.1215 11.2092 5.28972 11.2092 5.51402V11.0093C11.2092 11.2336 11.0441 11.4019 10.824 11.4019H5.43084C5.26574 11.4579 5.04561 11.2336 5.04561 11.0093ZM14.9514 14.486C14.9514 14.7103 14.7863 14.8785 14.5662 14.8785H9.17303C8.9529 14.8785 8.7878 14.7103 8.7878 14.486V12.5794H10.9341C11.7595 12.5794 12.4199 11.9065 12.4199 11.0654V8.59813H14.5662C14.7863 8.59813 14.9514 8.76636 14.9514 8.99065V14.486Z",
    fill: "#2E3438"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.bd4ca613a8969c179419474c31b24c37.svg";
export { ForwardRef as ReactComponent };